/* eslint-disable consistent-return */
import { apileads } from '../enviroment/apileads';

const getMunicipios = async () => {
  const response = await apileads.get('/v1/municipios');
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

export {
  getMunicipios,
};
